import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@repo/design-system/components/ui/skeleton";
export function MapSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-[320px] w-full bg-[#aad3df] md:h-[390px]" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function FilterbarSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-9 animate-pulse rounded bg-white/20" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid grid-flow-row gap-y-6 md:grid-cols-2 md:items-center md:gap-x-6"><Skeleton className="h-9 animate-pulse rounded bg-white/20" /><Skeleton className="h-9 animate-pulse rounded bg-white/20" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="grid min-h-[280px] w-full justify-items-center bg-gradient-tke px-6 py-4 text-white md:min-h-[320px] md:px-10 md:py-8" id="filterbar"><div className="grid w-full max-w-screen-xl gap-6">{t0}{t1}<div className="grid grid-flow-row gap-y-6 md:grid-cols-2 md:gap-x-6 xl:grid-cols-4"><Skeleton className="h-9 animate-pulse rounded bg-white/20" /><Skeleton className="h-9 animate-pulse rounded bg-white/20" /><Skeleton className="h-9 animate-pulse rounded bg-white/20" /><Skeleton className="h-9 animate-pulse rounded bg-white/20" /></div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function JoblistSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="mb-10 min-h-[600px] px-6 md:px-10"><div className="my-8 w-full max-w-screen-xl"><div className="mb-4 h-8 animate-pulse rounded bg-gray-200" />{Array.from({
          length: 10
        }).map(_temp)}</div></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

// Skeleton mirrors the real Joblist structure AND its measured row heights
// (header 76px, rows 101px, same outer-container/inner-container/table) so the
// skeleton <-> loaded swap is height-neutral and does not cause layout shift.
function _temp(_, i) {
  return <div className="border-b py-4" key={`skeleton-${i}`}><Skeleton className="mb-2 h-6 animate-pulse rounded bg-gray-200" /><Skeleton className="h-4 w-2/3 animate-pulse rounded bg-gray-200" /></div>;
}
export function JobListSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="outer-container pb-6 text-lg md:pb-20"><div className="inner-container"><table className="my-8 w-full table-fixed border-collapse" role="table"><thead className="border-gray-400 border-b"><tr className="grid h-[76px] grid-cols-joblist-small items-center justify-items-start pr-2 sm:pr-0 md:grid-cols-joblist-medium md:pl-4 lg:grid-cols-joblist-large"><Skeleton as="th" className="h-6 w-24" /><Skeleton as="th" className="hidden h-6 w-24 md:block" /><Skeleton as="th" className="hidden h-6 w-24 md:block" /><Skeleton as="th" className="hidden h-6 w-12 lg:block" /></tr></thead><tbody>{Array.from({
              length: 20
            }).map(_temp2)}</tbody></table></div></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp2(_, i) {
  return <tr className="grid h-[101px] grid-cols-joblist-small items-center justify-items-start border-gray-200 border-b pr-4 sm:pr-0 md:grid-cols-joblist-medium md:pl-4 lg:grid-cols-joblist-large" key={i}><td className="w-full pr-1"><Skeleton as="span" className="h-6 w-full max-w-md" /></td><td className="hidden w-full pr-1 md:block"><Skeleton as="span" className="h-6 w-2/3" /></td><td className="hidden w-full pr-1 md:block"><Skeleton as="span" className="h-6 w-2/3" /></td><td className="hidden w-full justify-items-center pr-1 lg:block"><Skeleton as="span" className="size-8" /></td></tr>;
}